var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15104 1.225H9.85104C10.4927 1.225 11.0177 1.75 11.0177 2.39167V3.675C11.0177 4.14167 10.726 4.725 10.4344 5.01667L7.92604 7.23334C7.57604 7.525 7.34271 8.10834 7.34271 8.575V11.0833C7.34271 11.4333 7.10937 11.9 6.81771 12.075L6.00104 12.6C5.24271 13.0667 4.19271 12.5417 4.19271 11.6083V8.51667C4.19271 8.10834 3.95938 7.58334 3.72604 7.29167L1.50938 4.95834C1.21771 4.66667 0.984375 4.14167 0.984375 3.79167V2.45C0.984375 1.75 1.50937 1.225 2.15104 1.225Z",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d658f2ed9d1d41755886f4f7de997280.svg";
export { ForwardRef as ReactComponent };